import { FC } from 'react';
import { ICaremapNote, ICaremapNoteResponse } from '../model/NotesClient';
import { IRecording } from '../../appointments/recording/RecordingState';
import { IonItem, IonLabel } from '@ionic/react';
import { CareMapNotesListTitle } from './CareMapNotesListTitle';
import { CareMapNotesListContent } from './CareMapNotesListContent';
import { AttachmentList } from '../generic-notes/attachments/AttachmentList';
import { RecordingInfo } from '../../appointments/recording/RecordingInfo';
import { NotesListActionItemCount } from './NotesListActionItemCount';
import { NotesListSummarizedByAI } from './NotesListSummarizedByAI';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    recordingInfoWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,

        // ensure no wrapping on smaller phones
        // TODO: avoid "items" getting clipped
        marginRight: -30,

        // NOTE: don't make this a common practice, of media queries in between breakpoints. very specific case (School Team Member Detail)
        '@media (max-width: 389px)': {
            gap: 7
        }
    }
});

export type ICareMapNotesListItemProps = {
    note: ICaremapNoteResponse | ICaremapNote;
    onClick?: () => void;
    button?: boolean;
    detail?: boolean;
    showPrivacy?: boolean;
    showNoteTargetHeader?: boolean;
    lines?: 'full' | 'inset' | 'none';
};

export const CareMapNotesListItem: FC<ICareMapNotesListItemProps> = ({
    note,
    onClick,
    button = true,
    detail = true,
    showPrivacy = true,
    showNoteTargetHeader,
    lines
}) => {
    const classes = useStyles();
    const recording = note.otherAttributes.recording as IRecording;

    return (
        <IonItem
            button={button}
            detail={detail}
            lines={lines}
            onClick={onClick}
            data-type="note-item"
            data-node-id={note.noteId}
            style={{'--border-radius': '8px'}}
        >
            <IonLabel class="ion-text-wrap">
                <CareMapNotesListTitle
                    note={note}
                    showPrivacy={showPrivacy}
                    showNoteTargetHeader={showNoteTargetHeader}
                />

                <CareMapNotesListContent note={note} />

                {!recording && (
                    <AttachmentList
                        note={note}
                        attachments={note.attachments}
                    />
                )}

                <div className={classes.recordingInfoWrapper}>
                    <RecordingInfo recording={recording} />
                    <NotesListSummarizedByAI recording={recording} />
                    <NotesListActionItemCount recording={recording} />
                </div>
            </IonLabel>
        </IonItem>
    );
};
